export enum StoragePlaceKinds {
  Format = 1,
  Cache,
}
